import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { useNavigate } from "react-router-dom";
import { FiX } from "react-icons/fi";
import styles from "./AccountMigratedModal.module.scss";
import Icon, { IconWrapper } from "components/Icon/Icon";
import Button from "components/Button/Button";

export default function AccountMigratedModal({ isOpen, onClose }) {
  const navigate = useNavigate();

  const handleBackToHome = () => {
    onClose();
    navigate("/login", { state: { skipAccessInfoModal: true } });
  };

  const handleInformCpf = () => {
    onClose();
    navigate("/consultar-email/informar-cpf");
  };

  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "visible";
    return () => {
      document.body.style.overflow = "visible";
    };
  }, [isOpen]);

  return ReactDOM.createPortal(
    <div
      className={isOpen ? `${styles.dialog} ${styles.active}` : styles.dialog}
      onClick={onClose}
    >
      <div
        className={styles.content}
        onClick={(event) => event.stopPropagation()}
      >
        <IconWrapper onClick={onClose} className={styles.close}>
          <Icon>
            <FiX />
          </Icon>
        </IconWrapper>

        <img
          src="/access-info.png"
          alt="Tutora T.I.A"
          width={250}
          height={250}
          className={styles.image}
        />

        <div className={styles.text}>
          <h3 className={styles.title}>Esta conta foi migrada!</h3>
          <p>
            Para entrar na sua conta e não perder seu progresso, volte para a
            tela inicial e clique no botão "Entrar com meu e-mail SEDUC.PI"
            utilizando seu novo endereço.
          </p>
          <p className={styles.description}>
            Não sabe seu e-mail SEDUC.PI? Clique em "Consultar"
          </p>

          <div className={styles.btnGroup}>
            <Button
              modifiers={["primary"]}
              onClick={handleBackToHome}
              style={{
                padding: "8px 16px",
                fontSize: "1.4rem",
              }}
            >
              Voltar para a tela inicial
            </Button>

            <Button
              modifiers={["outline"]}
              onClick={handleInformCpf}
              style={{
                padding: "8px 16px",
                fontSize: "1.4rem",
              }}
            >
              Consultar
            </Button>
          </div>
        </div>
      </div>
    </div>,
    document.getElementById("modal_root"),
  );
}
